import React, { useState, useEffect } from "react";
import { Col, Radio, Row, DatePicker, Button, Space, Image } from "antd";
import {
  getIoMonitoringData,
  getNurseMonitoringData,
} from "../../../../services/nurse.services";
import useQuery from "../../../../hooks/useQuery";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import { PlusOutlined } from "@ant-design/icons";
import calenderIcon from "../../../../assets/images/nurseIcons/calender.svg";
import IoBalance from "./IoBalance";
import IoModalForm from "./IoModalForm";
import LoadingIndicator from "../../../Loaders/LoadingIndicator";
import VitalGrbsTable from "./VitalGrbsMonitoring/VitalGrbsTable";
import AddVitalGrbs from "./VitalGrbsMonitoring/AddVitalGrbs";
import dayjs from "dayjs";
import useCompactMonitoringLayout from "../../../../hooks/useCompactMonitoringLayout";
import useTabletMonitoringLayout from "../../../../hooks/useTabletMonitoringLayout";
import "./MonitoringMobile.css";

const dateFormat = "YYYY-MM-DD";
const options = [
  { title: "Vitals", value: "vitals" },
  { title: "GRBS", value: "grbs" },
  { title: "IO Monitoring", value: "io_monitoring" },
];

const MonitoringTabs = () => {
  const params = useQuery();
  const curDate = dayjs().format(dateFormat);
  const [active, setActive] = useState("vitals");
  const [date, setDate] = useState(curDate);
  const [data, setData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [ioOpen, setIoOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const isActive = params?.status === "current";
  const isCompact = useCompactMonitoringLayout();
  const isTablet = useTabletMonitoringLayout();

  const refreshPage = () => {
    setRefresh((prev) => !prev);
  };

  function disabledDate(current) {
    return current && current > dayjs().endOf("day");
  }

  const onDateChange = (date, dateString) => {
    setDate(date ? dateString : null);
  };

  useEffect(() => {
    setLoading(true);
    if (active !== "io_monitoring") {
      const queryParam =
        active === "grbs" ? `?date=${date}&type=grbs` : `?date=${date}`;

      getNurseMonitoringData(params?.patient, queryParam)
        .then((res) => {
          setData(res?.data?.data);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [refresh, params?.patient, date, active]);

  useEffect(() => {
    if (active === "io_monitoring") {
      setLoading(true);
      getIoMonitoringData(params?.patient, `?date=${date}`)
        .then((res) => {
          setData(res?.data?.data);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => setLoading(false));
    }
  }, [refresh, params?.patient, date, active]);

  return (
    <Row className="nurse-monitoring-tabs" gutter={[12, 12]}>
      <Col span={24}>
        <div
          className={[
            "nurse-monitoring-controls",
            isTablet ? "nurse-monitoring-controls--tablet" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <div className="nurse-monitoring-controls-primary">
            <Radio.Group
              className="nurse-monitoring-tab-group"
              onChange={(e) => setActive(e.target.value)}
              buttonStyle="solid"
              defaultValue={active}
            >
              {options?.map((item) => (
                <Radio.Button key={item?.value} value={item?.value}>
                  {item?.title}
                </Radio.Button>
              ))}
            </Radio.Group>
          </div>

          <div className="nurse-monitoring-date-wrap">
            <DatePicker
              style={{
                border: "1px solid #a182e3",
                height: "38px",
                boxSizing: "border-box",
              }}
              disabledDate={disabledDate}
              className={`${inputStyles.mdDateInput} nurse-monitoring-date-picker`}
              onChange={onDateChange}
              defaultValue={dayjs(curDate)}
              allowClear={false}
              suffixIcon={<Image width={20} src={calenderIcon} preview={false} />}
              placement="bottomLeft"
              popupClassName={isCompact ? "curengo-mobile-picker" : undefined}
              getPopupContainer={() => document.body}
            />
          </div>

          {isActive && (
            <Space className="nurse-monitoring-controls-actions" size={8} wrap={false}>
              <Button
                style={{ height: "36px", fontWeight: 500 }}
                type="primary"
                ghost
                className={`${btnStyles.mdBtn} inv-btn`}
                onClick={() => {
                  active === "io_monitoring" ? setIoOpen(true) : setOpen(true);
                }}
              >
                <PlusOutlined /> SOS
              </Button>
            </Space>
          )}
        </div>
      </Col>
      <Col span={24}>
        {loading ? (
          <div style={{ marginBottom: "200px" }}>
            <LoadingIndicator message="Loading monitoring data, please wait..." />
          </div>
        ) : active === "io_monitoring" ? (
          <IoBalance
            data={data}
            refresh={refreshPage}
            loading={loading}
            date={date}
          />
        ) : (
          <VitalGrbsTable
            data={data}
            refresh={refreshPage}
            loading={loading}
            type={active}
          />
        )}
      </Col>

      {open && (
        <AddVitalGrbs
          open={open}
          setOpen={setOpen}
          refresh={refreshPage}
          date={date}
          type={active}
        />
      )}
      {ioOpen && (
        <IoModalForm
          open={ioOpen}
          setOpen={setIoOpen}
          refresh={refreshPage}
          date={date}
        />
      )}
    </Row>
  );
};

export default MonitoringTabs;
